/* start - flights_split_bounds_us */
import { getInitialState as getSearchResultsInitialState, State as SearchResultState } from "../searchResults/state";

export type State = {
  outbound: SearchResultState;
  inbound: SearchResultState;
};

export const getInitialState = (): State => ({
  outbound: getSearchResultsInitialState(),
  inbound: getSearchResultsInitialState()
});
/* end - flights_split_bounds_us */
